import { CSSObject } from '@emotion/css';

import { linkStyles } from './link-styles';
import { tableStyles } from './table-styles';
import { textStyles } from './text-styles';

export const renderedHtmlStyle: CSSObject = {
  display: 'block',
  fontSize: '1rem',
  fontWeight: 'var(--font-weight-light)',
  lineHeight: '1.5rem',
  padding: 0,
  paddingBottom: '3rem',
  paddingRight: '3rem',
  ...linkStyles,
  ...tableStyles,
  ...textStyles,
};
